import {
  GetObraMateriaisControladosDropDown,
  GetObraMateriaisControladosDropDownResponse,
} from "../../../data/daos/read/get_obra_materiais_controlados_dropdown";
import { IObraMateriaisControladosDropDownUseCase } from "../../../presentation/useCases/read/obra_materiais_controlados_drop_down_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * ObraMateriaisControladosDropDownUseCase
 */

export class ObraMateriaisControladosDropDownUseCase implements IObraMateriaisControladosDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async obraMateriaisControladosDropDown(id: number): Promise<GetObraMateriaisControladosDropDown[]> {
    const response = await this.repository.obrasMateriaisControladosDropdown({ id });
    return response;
  }
}
